import React from 'react';
import { IOption } from './selectInput';
import InputWithUnitLabel from './inputWithUnitLabel';

interface InputWithToggleLabelProps {
  type: React.HTMLInputTypeAttribute;
  value: any;
  label: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  toggle?: boolean;
  handleToggle?: () => void;
  unitLabel?: string;
  min?: number;
  max?: number;
  step?: number;
  options?: IOption[];
  disabled?: boolean;
  error?: string;
  placeholder?: string;
}

function InputWithToggleLabel(props: InputWithToggleLabelProps) {
  const {
    type,
    value,
    label,
    handleChange,
    toggle,
    handleToggle,
    unitLabel,
    min,
    max,
    step,
    options,
    disabled,
    error,
    placeholder,
  } = props;

  return (
    <>
      <div
        id="inputwithtogglelabel-wrapper"
        className="flex flex-row items-center h-full min-w-[45%]"
      >
        {toggle ? (
          <label
            id="inputwithtogglelabel-container"
            className="flex gap-2 items-center h-full mt-1.5"
          >
            <input
              id="inputwithtogglelabel-checkbox"
              type="checkbox"
              checked={!disabled}
              onChange={handleToggle}
              className="w-4 h-4 text-blue-600 bg-gray-100 shrink-0"
            />
            {label && (
              <span
                id={`inputwithtogglelabel-value-${label}-toogle`}
                className="flex flex-row gap-2 items-center"
                title={error}
              >
                {label}
              </span>
            )}
          </label>
        ) : (
          <span
            id={`inputwithtogglelabel-value-${label}`}
            className="flex flex-row gap-4 items-center"
            title={error}
          >
            {label}
          </span>
        )}
      </div>
      {type !== 'checkbox' ? (
        <div
          id="inputwithtogglelabel-non-checkbox"
          className="flex flex-row rounded-sm overflow-hidden items-center min-w-[55%]"
          style={
            type !== 'range'
              ? {
                  border: !disabled && error ? '1px solid red' : '1px solid black',
                }
              : null
          }
        >
          <InputWithUnitLabel
            type={type}
            value={value || ''}
            unitLabel={unitLabel}
            handleChange={handleChange}
            options={options}
            min={min}
            max={max}
            step={step}
            disabled={disabled}
            error={error}
            placeholder={placeholder}
          />
        </div>
      ) : null}
    </>
  );
}

export default InputWithToggleLabel;
